import MyDropzone from './MyDropzone';
import { errorToast } from '../../helpers/toastHelper';
import ModalButtonArea from '../ModalButtonArea';
import { Stack } from 'react-bootstrap';
import { icons } from '../../assets';
import BigButton from '../BigButton';
import { useState } from 'react';
import { compare } from "../../helpers/jsHelper";
const { BinIcon } = icons;

const UploadFileDialog = (props) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  function isFilePresent(file) {
    if (selectedFiles.length === 0) return Promise.resolve(false);

    return Promise.all(selectedFiles.map((sf) => compare(sf.file, file))).then((res) => {
      const x = res.every((r) => r === false);
      return !x;
    });
  }

  const handleFileChange = (files) => {
    const existingFiles = [...selectedFiles].map(a => {
      if(files.find(file => file.name === a.name)) {
        return undefined;
      } return a;
    }).filter(a => a !== undefined);
    setSelectedFiles([...existingFiles, ...files]);
  };

  const handleFileDelete = (index) => {
    const updatedFiles = selectedFiles.filter((_, fileIndex) => index !== fileIndex);
    setSelectedFiles(updatedFiles);
  };

  const resetFiles = (uploadedFiles=[]) => {
    if (uploadedFiles.length){
      setSelectedFiles(selectedFiles.filter(a => !uploadedFiles.includes(a?.name)))
    }
    else setSelectedFiles([]);
  }

  return (
    <ModalButtonArea
      {...props}
      size="md"
      centered={false}
      bigButton={true}
      variant="warning"
      buttonTitle={props.buttonTitle}
      iconBefore={props.iconBefore}
      onClose={resetFiles}
      className="texture-upload-modal black-btn keep-text"
      title={
        <>
          <p className="title">Import file</p>
          <p className="sub-title">Add files [ excel ] </p>
        </>
      }
      body={
        <>
          <MyDropzone onDrop={handleFileChange} />
          {selectedFiles.length > 0 && (
            <Stack>
              <div
                style={{
                  maxHeight: 214,
                  overflowY: 'auto',
                  marginTop: '1.5rem',
                  marginBottom: '2rem',
                }}>
                <table className="bordered">
                  <tbody>
                    {selectedFiles.map((file, index) => (
                      <tr key={index}>
                        <td>
                          <span>{file.name}</span>
                          <span
                            onClick={() => handleFileDelete(index)}
                            style={{ cursor: 'pointer' }}>
                            <BinIcon />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <BigButton
                disabled={props?.isLoading}
                isLoading={props?.isLoading}
                className="lf-btn-1"
                buttonTitle="Import"
                onClick={() => props?.handleFileImport(selectedFiles, resetFiles)}
              />
            </Stack>
          )}
        </>
      }
    />
  );
};

export default UploadFileDialog;
